export default __webpack_public_path__ + "static/auto_assign-edc0fe75d9aea6166545bbd6ec320128.png";